import React from "react";

export class AppErrorBoundary extends React.Component {
  state = { hasError: false, resetKey: 0 };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[error-boundary] caught:", error, info?.componentStack);
    const msg = String(error?.message || error?.name || "");
    const isDomTampering =
      msg.includes("removeChild") || msg.includes("insertBefore") || msg.includes("NotFoundError");
    if (isDomTampering && !this._recovering) {
      // DOM was mutated by an external script (ads, translate): remount the tree silently
      this._recovering = true;
      setTimeout(() => { this._recovering = false; }, 5000);
      this.setState((s) => ({ hasError: false, resetKey: s.resetKey + 1 }));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 16,
          fontFamily: "sans-serif", background: "#FAF9F6", color: "#1C1917", padding: 24,
        }} data-testid="app-error-fallback">
          <h1 style={{ fontSize: 22, fontWeight: 800 }}>Oups, une erreur est survenue</h1>
          <p style={{ color: "#57534E", textAlign: "center" }}>
            Rechargez la page pour continuer. Si le problème persiste, contactez contact@afrimeet.org.
          </p>
          <button
            onClick={() => window.location.reload()}
            data-testid="app-error-reload-btn"
            style={{
              background: "#B8862D", color: "#fff", border: "none", borderRadius: 6,
              padding: "12px 24px", fontWeight: 700, cursor: "pointer",
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return <React.Fragment key={this.state.resetKey}>{this.props.children}</React.Fragment>;
  }
}
